import React from 'react'
//import demo from "../akshay.jpg"
import axios from "axios";
import NavFormProfile from './NavFormProfile';
//import { Link } from "react-router-dom";
import Path from "./config";
//import Moment from 'moment';
import AdminNavFormProfile from './AdminNavFormProfile';

class Nondani extends React.Component {
    constructor(props) {
        super(props);
        //for radiodisabled onchange
        //this.showScanType = this.showScanType.bind(this);

        this.state = {
            sbg_lpid: '',
            NavMenu: false,
            sbg_lpid_status: '',
            enterId: '',
            showInfo: ''
        }
    }
    componentDidMount() {
        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }

        axios.get(Path + 'Suchi_bride_groom_nondani.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;

                this.setState({
                    sbg_lpid_status: response.sbg_lpid_status,
                    sbg_lpid: response.sbg_lpid,

                })
            }.bind(this))

    }

    lpidHandler = (e) => {
        this.setState
            ({ sbg_lpid_status: e.target.value }, () => {

                if (this.state.sbg_lpid_status === "yes") {
                    this.setState({
                        enterId: true,
                        showInfo: false
                    })
                }
                else {
                    this.setState({
                        enterId: false,
                        showInfo: true
                    })
                }
            })
    }

    valHandler = (e) => {

        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_lpid: e.target.value })
        }
    }

    submitLpid = () => {
        let typee = "lpid";
        let isValid = true;

        if (this.state.sbg_lpid === "") {
            document.getElementById("sbg_lpid").style.borderColor = "red";
            isValid = false;
        }
        if (isValid === true) {
            let tempStr = "sbg_lpid=" + this.state.sbg_lpid +
                "&sbg_id=" + localStorage.getItem("userId") +
                "&type=" + typee
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    if (response.data.status === "updated") {
                        alert("Updated Successfully");
                    }
                })
        }
    }
    nextClick = () => {
        let typee = "lpid";
        if (this.state.admin === "Admin") {
            this.props.history.push(`/AdminProfile/FullbiodataAdmin`);
        }
        else {
            let tempStr = "sbg_lpid=" + this.state.sbg_lpid +
                "&sbg_id=" + localStorage.getItem("userId") +
                "&type=" + typee
            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    if (response.data.status === "updated") {
                        alert("Updated Successfully");
                    }
                })
            this.props.history.push(`/FormProfile/Fullbiodata`);
        }
    }



    render() {

        return (
            <>

                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className=" m-5 border border-secondary bg-white p-5 lh-base">
                    <div className="row g-3  ">
                        <div className="col-md-8 bg-warning p-3">
                            <b>  तुमची लेवा शुभमंगल मोबाईल सूचित नाव नोंदणी आहे का ? </b>&nbsp;&nbsp;

                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="sbg_lpid_status" value="yes" checked={this.state.sbg_sex === 'yes'} onChange={this.lpidHandler} id="inlineRadio1" />
                                <label className="form-check-label" htmlFor="inlineRadio1">होय  </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="sbg_lpid_status" value="no" checked={this.state.sbg_sex === 'no'} onChange={this.lpidHandler} id="inlineRadio2" />
                                <label className="form-check-label" htmlFor="inlineRadio2">नाही</label>
                            </div>
                        </div>

                    </div>

                    {this.state.enterId ?
                        <div className="row g-3  ">
                            <div className="col-md-8 bg-warning p-3">
                                <label htmlFor="formGroupExampleInput2" className="form-label">  LP ID टाकावा</label><br></br>
                                LP - <input type="text" id="sbg_lpid" className="txt_box" maxLength="6" value={this.state.sbg_lpid} onChange={this.valHandler} style={{ width: "120px" }} />
                                <button className="btn-success btn" onClick={() => this.submitLpid()}>OK</button>
                            </div>
                        </div>
                        : null}
                    {this.state.showInfo ?
                        <div className="row g-3  ">
                            <div className="col-md-8 bg-warning p-3">

                                <a href="https://play.google.com/store/apps/details?id=com.flyctsofttech.matrimonialapp" target="_blank" rel="noreferrer">
                                    https://play.google.com/store/apps/details?id=com.flyctsofttech.matrimonialapp</a>
                                <br></br>
                                या लिंक वर क्लिक करून आपण  मोबाईल अँप सुचिसाठी नोंदणी करून आताच

                                अँप मध्ये हवे तसे वयानुसार, शिक्षणानुसार, लोकेशन नुसार, उंची नुसार असे
                                विविध फिल्टर लावून आता पासूनच स्थळं शोधू शकतात.
                                <br></br>
                                <b> महत्वाची ऑफर* <br></br>
                                    लेवा शुभमंगल वधु-वर पुस्तक सूचित नोंदणी केल्या नंतर मोबाईल अँप सूचित ज्यांची  नाव नोंदणी नसेल
                                    त्यांच्या साठी 200 रुपये जास्तीची सवलत राहील ती सवलत  आपण पेकेज घेण्यासाठी वापरू शकतात.
                                    सवलत मिळविण्यासाठी पुस्तकात नाव टाकल्यानंतर लगेच अँप लिंक वर क्लिक करून 5 दिवसात नोंदणी
                                    पूर्ण करणे अत्याआवश्यक आहे.
                                </b><br></br><br></br>
                                मोबाईल अँप सूची च्या नोंदणी साठी काहीही अडचण आल्यास ऑफिस ला संपर्क करावा.
                            </div>
                        </div>
                        : null}

                    <br></br>  <br></br>
                    <div className="col-12">
                        <button type="submit" className="btn btn-primary" onClick={(e) => (this.nextClick) ? this.nextClick(e) : null}>Next </button>
                    </div>
                </div>

            </>
        )
    }
}

export default Nondani